<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-decoration__manualconfig">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="学年" prop="schoolYearName">
          <el-select v-model="dataForm.id" placeholder="学年表" @change="handleChange">
            <el-option
                    v-for="item in yearList"
                    :key="item.id"
                    :label="item.schoolYearName"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button  type="primary" @click="exportSheet()">导出汇总表</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
        <el-table-column :label=title header-align="center" align="center">
          <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
          <el-table-column prop="month_10" :label="detail.month_10" header-align="center" align="center"></el-table-column>
          <el-table-column prop="month_11" :label="detail.month_11" header-align="center" align="center"></el-table-column>
          <el-table-column prop="month_12" :label="detail.month_12" header-align="center" align="center"></el-table-column>
          <el-table-column prop="toatalNum0" :label="detail.toatalNum0" header-align="center" align="center"></el-table-column>
          <el-table-column prop="month_3" :label="detail.month_3" header-align="center" align="center"></el-table-column>
          <el-table-column prop="month_4" :label="detail.month_4" header-align="center" align="center"></el-table-column>
          <el-table-column prop="month_5" :label="detail.month_5" header-align="center" align="center"></el-table-column>
          <el-table-column prop="toatalNum1" :label="detail.toatalNum1" header-align="center" align="center"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './manualconfig-add-or-update'
import ExportconfigAddOrUpdate from './exportconfig-add-or-update'
import ViewManual from './view-manual'
import { Loading } from 'element-ui'
import Cookies from 'js-cookie'
import qs from 'qs'
import ClassDecorationProgress from './class-decoration-progress'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/decoration/manualconfig/page',
        getDataListIsPage: true,
        exportURL: '/decoration/manualconfig/export',
        exportImgURL: '/decoration/manualConfig/exportImg',
        deleteURL: '/decoration/manualconfig',
        deleteIsBatch: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      gradeList: [],
      termTableList: [],
      yearList: [],
      dataList: [],
      classList: [],
      exportVisible: false,
      viewVisible: false,
      progressVisible: false,
      termName: '',
      yearId: '',
      dataForm: {
        id: '',
        termId: ''
      },
      title: '',
      detail: ''
    }
  },
  mounted () {
    this.getYearList()
  },
  methods: {
    getYearList () {
      this.$http
        .get(
          '/decoration/manualConfig/getTermTableByTermYear'
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.yearList = data.data
          if (this.yearList.length > 0) {
            this.dataForm.id = this.yearList[0].id
          }
          this.getTableTitle()
        })
    },
    // 获取表头数据
    getTableTitle () {
      this.$http
        .get(
          '/decoration/manualConfig/getDecorationTypeAndDecoration', {
            params: {
              termYearId: this.dataForm.id
            }
          }
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.termTableList = data.data.detail
          if (this.termTableList.length > 0) {
            this.dataForm.termId = this.termTableList[0].termId
            console.log(this.dataForm.termId)
          }
          // const obj = {}
          // obj.detail = data.data.detail
          // obj.title = data.data.title
          // this.dataList.push(obj)
          this.title = data.data.title
          this.detail = data.data.detail
          this.getStatistics()
        })
    },
    // 获取表格数据
    getStatistics () {
      this.$http
        .get(
          '/decoration/manualConfig/getStatisticsNumberOfDisputesByClass', {
            params: {
              termYearId: this.dataForm.id

            }
          }
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          data.data.forEach(e => {
            this.dataList.push(e)
          })
          console.log('data', this.dataList)
        })
    },
    handleChange () {
      this.getYearList()
    },
    exportSheet () {
      const params = qs.stringify({
        token: Cookies.get('token'),
        termYearId: this.dataForm.id
      })
      window.open(`${window.SITE_CONFIG.apiURL}/decoration/manualConfig/exportStatisticsNumberOfDisputes?${params}`)
    }
  },
  components: {
    ClassDecorationProgress,
    ExportconfigAddOrUpdate,
    ViewManual,
    AddOrUpdate
  }
}
</script>
